import {
  AbstractJsonLexer1em5xl1wqsdtw as AbstractJsonLexer,
  charToTokenClass1wja4xge82waq as charToTokenClass,
  tokenDescription3r6eqmtoxe76u as tokenDescription,
} from './AbstractJsonLexer.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { indexOf1xbs558u7wr52 as indexOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringJsonLexerWithComments3bzrli3gl2cah as StringJsonLexerWithComments } from './CommentLexers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringJsonLexerClass;
function StringJsonLexer() {
  if (StringJsonLexerClass === VOID) {
    class $ extends AbstractJsonLexer() {
      constructor(source, configuration) {
        super(configuration);
        this.source_1 = source;
      }
      get_source_jl0x7o_k$() {
        return this.source_1;
      }
      prefetchOrEof_k52kdy_k$(position) {
        return position < this.get_source_jl0x7o_k$().length ? position : -1;
      }
      consumeNextToken_uf1vsa_k$() {
        var source = this.get_source_jl0x7o_k$();
        var cpos = this.currentPosition_1;
        $l$loop: while (!(cpos === -1) && cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.currentPosition_1 = cpos;
          return charToTokenClass(c);
        }
        this.currentPosition_1 = source.length;
        return 10;
      }
      canConsumeValue_oljqd7_k$() {
        var current = this.currentPosition_1;
        if (current === -1)
          return false;
        var source = this.get_source_jl0x7o_k$();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
            continue $l$loop;
          }
          this.currentPosition_1 = current;
          return this.isValidValueStart_kdgv46_k$(c);
        }
        this.currentPosition_1 = current;
        return false;
      }
      skipWhitespaces_ox013r_k$() {
        var current = this.currentPosition_1;
        if (current === -1)
          return current;
        var source = this.get_source_jl0x7o_k$();
        $l$loop: while (current < source.length) {
          var c = charCodeAt(source, current);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
            current = current + 1 | 0;
          } else {
            break $l$loop;
          }
        }
        this.currentPosition_1 = current;
        return current;
      }
      consumeNextToken_kteg6b_k$(expected) {
        if (this.currentPosition_1 === -1) {
          this.unexpectedToken_u9lezp_k$(expected);
        }
        var source = this.get_source_jl0x7o_k$();
        var cpos = this.currentPosition_1;
        $l$loop: while (cpos < source.length) {
          var _unary__edvuaz = cpos;
          cpos = _unary__edvuaz + 1 | 0;
          var c = charCodeAt(source, _unary__edvuaz);
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
          if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
            continue $l$loop;
          this.currentPosition_1 = cpos;
          if (c === expected)
            return Unit_instance;
          this.unexpectedToken_u9lezp_k$(expected);
        }
        this.currentPosition_1 = -1;
        this.unexpectedToken_u9lezp_k$(expected);
      }
      consumeKeyString_mfa3ws_k$() {
        this.consumeNextToken_kteg6b_k$(_Char___init__impl__6a9atx(34));
        var current = this.currentPosition_1;
        var closingQuote = indexOf(this.get_source_jl0x7o_k$(), _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
          this.consumeStringLenient_9oypvu_k$();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
          var expected = tokenDescription(1);
          var position = false && this.currentPosition_1 > 0 ? this.currentPosition_1 - 1 | 0 : this.currentPosition_1;
          var s = this.currentPosition_1 === charSequenceLength(this.get_source_jl0x7o_k$()) || position < 0 ? 'EOF' : toString(charSequenceGet(this.get_source_jl0x7o_k$(), position));
          var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
          this.fail$default_ly4hfp_k$(tmp$ret$1, position);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charCodeAt(this.get_source_jl0x7o_k$(), i) === _Char___init__impl__6a9atx(92)) {
              return this.consumeString2(this.get_source_jl0x7o_k$(), this.currentPosition_1, i);
            }
          }
           while (inductionVariable < closingQuote);
        this.currentPosition_1 = closingQuote + 1 | 0;
        return substring(this.get_source_jl0x7o_k$(), current, closingQuote);
      }
      peekLeadingMatchingValue_y3am18_k$(keyToMatch, isLenient) {
        var positionSnapshot = this.currentPosition_1;
        try {
          if (!(this.consumeNextToken_uf1vsa_k$() === 6))
            return null;
          var firstKey = this.peekString_d4c947_k$(isLenient);
          if (!(firstKey === keyToMatch))
            return null;
          this.discardPeeked_n23g48_k$();
          if (!(this.consumeNextToken_uf1vsa_k$() === 5))
            return null;
          return this.peekString_d4c947_k$(isLenient);
        }finally {
          this.currentPosition_1 = positionSnapshot;
          this.discardPeeked_n23g48_k$();
        }
      }
    }
    initMetadataForClass($, 'StringJsonLexer');
    StringJsonLexerClass = $;
  }
  return StringJsonLexerClass;
}
function StringJsonLexer_0(json, source) {
  return !json.configuration_1.allowComments_1 ? new (StringJsonLexer())(source, json.configuration_1) : new (StringJsonLexerWithComments())(source, json.configuration_1);
}
//region block: exports
export {
  StringJsonLexer_0 as StringJsonLexer3eu6xom7mrcfu,
  StringJsonLexer as StringJsonLexervr9dj3kex5li,
};
//endregion

//# sourceMappingURL=StringJsonLexer.mjs.map
